"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeathEffectHandler = exports.DeathEffectArgs = void 0;
const __1 = require("../../..");
const enums_1 = require("../../enums");
const AllyKilled_1 = require("../../events/core/AllyKilled");
const EnemyKilled_1 = require("../../events/core/EnemyKilled");
const Killed_1 = require("../../events/core/Killed");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const core_1 = require("../../vfx/core");
const AnimateCharacter_1 = require("../../vfx/core/AnimateCharacter");
const EffectType_1 = require("../EffectType");
class DeathEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Death;
        this.__typeName = "Death";
        this.name = "Death";
        this.harmful = true;
    }
}
exports.DeathEffectArgs = DeathEffectArgs;
let DeathEffectHandler = class DeathEffectHandler {
    apply(sequence, container, state) {
        // supernatural death cannot be avoided!
        if (!state.supernatural && container.hasEffectOfType(state.targetId, EffectType_1.EffectType.AvoidDeath)) {
            // need to cancel self.
            container.cancelEffect(sequence, state.id);
            const [toConsume] = container.getEffectsOfType(state.targetId, EffectType_1.EffectType.AvoidDeath);
            container.emitEvent(sequence, state.targetId, new __1.DeathAvoidedEventArgs(toConsume));
            container.cancelEffect(sequence, toConsume);
            return;
        }
        sequence.pushSequence("parallel")
            .push(AnimateCharacter_1.AnimateCharacterVfxStepArgs.Killed(state.targetId))
            .push(new __1.UpdateTurnMeterVfxStepArgs(state.targetId, 0))
            .push(new core_1.CharacterSoundEffectVfxStepArgs(state.targetId, "killed"))
            .push(new __1.BattleLogEntryVfxStepArgs([
            __1.BattleLogEntrySegment.actorName(container, state.creatorId),
            new __1.BattleLogEntrySegment(" killed "),
            __1.BattleLogEntrySegment.actorName(container, state.targetId)
        ]));
        container.setTurnMeter(sequence, state.targetId, 0);
        if (container.getAttributeScore(state.targetId, enums_1.AttributeType.Health) > 0) {
            container.setHealth(sequence, state.targetId, 0);
        }
        const eventSequence = sequence.pushSequence("parallel");
        container.emitEvent(eventSequence, state.targetId, new Killed_1.KilledEventArgs(state.creatorId));
        container.emitEvent(eventSequence, 0, new __1.ActorKilledEventArgs(state.creatorId, state.targetId));
        for (const ally of container.selectTargets(state.targetId, Target_1.Target.AllAllies)) {
            container.emitEvent(eventSequence, ally, new AllyKilled_1.AllyKilledEventArgs(state.targetId));
        }
        for (const enemy of container.selectTargets(state.targetId, Target_1.Target.AllEnemies)) {
            container.emitEvent(eventSequence, enemy, new EnemyKilled_1.EnemyKilledEventArgs(state.targetId));
        }
    }
    remove(sequence, container, state) {
        // TODO: Do we support removing this effect?
    }
};
DeathEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Death)
], DeathEffectHandler);
exports.DeathEffectHandler = DeathEffectHandler;
